module.exports = __webpack_public_path__ + "media/images/icon-sme-ce3cb534b958d4e6ff81340be3751e25.png";